import { permissionCode } from "src/app/shared";
import { FeaturePermissionState } from "../permission.models";

export const epicsPermissionState: FeaturePermissionState = {
  view: [permissionCode.TASK_MANAGEMENT_EPIC_EPIC_VIEW],
  edit: [permissionCode.TASK_MANAGEMENT_EPIC_EPIC_EDIT],
}
